export default {
  balance: '{{value}}p ({{moneyValue}}) verfügbar',
  optional: 'Nutze oder sammle weiter Punkte',
  states: {
    on: 'Ja',
    off: 'Nein',
  },
  feedback: {
    min_spending_limit_not_reached: 'Löse deine Punkte ein, sobald du min. {{value}} Punkte hast',
    max_spending_limit: 'Maximal {{value}} Punkte pro Bestellung',
  },
  cashback: {
    enabled: 'Punkte erfolgreich angewendet',
  },
};
